// If we have a state, and that state has language data, return the language
export const resolveLanguageFromContextData = (state) => {
  return (state && state.sitecore && state.sitecore.context && state.sitecore.context.language) || null;
};

export const resolveLanguageFromConfig = (config) => {
  return config && config.defaultLanguage;
};
